import { render } from "./Right.vue?vue&type=template&id=26776bfe"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Right.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "26776bfe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('26776bfe', __exports__)) {
    api.reload('26776bfe', __exports__)
  }
  
  module.hot.accept("./Right.vue?vue&type=template&id=26776bfe", () => {
    api.rerender('26776bfe', render)
  })

}


export default __exports__